import { Alert } from '@mui/material';
import { MouseRightClickIcon } from '@phosphor-icons/react';
import { useState } from 'react';

import { Text } from 'common';

export function FieldReferenceHelp() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) {
    return null;
  }

  return (
    <Alert
      severity="info"
      icon={<MouseRightClickIcon size={24} />}
      closeText="Dismiss field reference help"
      onClose={() => setIsVisible(false)}
    >
      <Text variant="body2" bold>
        Right-click any key or value to copy its reference
      </Text>
    </Alert>
  );
}
